var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabs"},[_vm._l((_vm.list),function(item,index){return [(item.state)?_c('div',{key:index,staticClass:"tabs-item",class:{
        'tabs-item-active': item.key === _vm.actived,
        'tabs-item-active-next': item.key === (_vm.actived + 1),
        'tabs-item-active-prev': item.key === (_vm.actived - 1)
        },on:{"click":function($event){return _vm.onChange(item)}}},[_c('span',[_vm._v(_vm._s(item.label))])]):_vm._e()]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }